import InventoryEditPrint from './InventoryEditPrint'
export default InventoryEditPrint
